import React, { useState, useEffect } from 'react';
import { Sparkles, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function LaunchBanner() {
  const [isLaunchMode, setIsLaunchMode] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Load launch mode status
    const loadLaunchMode = async () => {
      try {
        const response = await fetch(`${API_URL}/api/settings/launch-mode`);
        if (response.ok) {
          const data = await response.json();
          setIsLaunchMode(data.launch_mode === true);
        }
      } catch (error) {
        // Fallback to localStorage
        setIsLaunchMode(localStorage.getItem('rarifex_launch_mode') === 'true');
      }
    };

    loadLaunchMode();

    // Listen for launch mode changes
    const handleLaunchModeChange = (e) => {
      setIsLaunchMode(e.detail.enabled);
      setDismissed(false); // Reset dismissed state when mode changes
    };

    window.addEventListener('launchModeChanged', handleLaunchModeChange);
    return () => window.removeEventListener('launchModeChanged', handleLaunchModeChange);
  }, []);

  if (!isLaunchMode || dismissed) return null;

  return (
    <div className="bg-gradient-to-r from-[#DAA520] via-[#B8860B] to-[#DAA520] text-white py-2 px-4 relative">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base">
        <Sparkles className="w-4 h-4 flex-shrink-0 animate-pulse" />
        <span className="font-medium text-center">
          {/* Mobile (<sm): testo corto */}
          <span className="sm:hidden">
            Lancio Rarifex — <strong>commissione azzerata</strong>: sostieni gli artigiani italiani
          </span>
          {/* Tablet (sm - md) */}
          <span className="hidden sm:inline md:hidden">
            <strong>Sostieni gli artigiani italiani</strong>: durante il lancio Rarifex rinuncia alla propria commissione
          </span>
          {/* Desktop (≥md): frase completa */}
          <span className="hidden md:inline">
            Acquistando oggi <strong>sostieni direttamente gli artigiani italiani</strong>: durante il lancio Rarifex rinuncia alla propria commissione per far crescere la piattaforma
          </span>
        </span>
        <Sparkles className="w-4 h-4 flex-shrink-0 animate-pulse hidden sm:block" />
      </div>
      <button 
        onClick={() => setDismissed(true)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded transition-colors"
        aria-label="Chiudi banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
